import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { APP_URL, scrollToId } from "@/lib/site";

export const Footer = () => (
  <footer className="overflow-hidden border-t border-white/[0.07]">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
      <Logo testId="footer-brand-link" />
      <nav className="flex flex-wrap gap-6 text-sm text-[#b3b8c1]">
        <a href={APP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-open-app" className="hover:text-[#ff8a3d]">Web app</a>
        <button type="button" onClick={() => scrollToId("features")} data-testid="footer-features" className="hover:text-[#ff8a3d]">Features</button>
        <button type="button" onClick={() => scrollToId("pricing")} data-testid="footer-pricing" className="hover:text-[#ff8a3d]">Pricing</button>
        <button type="button" onClick={() => scrollToId("waitlist")} data-testid="footer-waitlist" className="hover:text-[#ff8a3d]">Waitlist</button>
        <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#ff8a3d]">Privacy</Link>
      </nav>
      <p className="text-xs text-[#9ca3af]">© 2026 Spotter by Breezy Labs · Made in Adelaide, Australia</p>
    </div>
    <p aria-hidden="true" className="pointer-events-none select-none text-center font-display text-[24vw] font-black uppercase leading-[0.75] tracking-tight text-outline">Spotter</p>
  </footer>
);
